import Vue from "vue";
import Vuex from "vuex";
import App from "./App.vue";
import router from "./router";
import VuexRest from "./plugins/vuex-rest";
import vuetify from "./plugins/vuetify";
import "./plugins/vue-grid";
import "./plugins/v-responsive";

const server =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_SERVER
    : location.origin;

Vue.config.productionTip = false;

Vue.use(Vuex);

Vue.use(VuexRest, {
  base: server + "/rest"
});

Vue.mixin({
  data: () => ({
    server,
    files: server
  })
});

new Vue({
  router,
  vuetify,
  store: new Vuex.Store(),
  render: function(h) {
    return h(App);
  }
}).$mount("#app");
